import { put, select } from "@redux-saga/core/effects";

import { getGoogleSheetsFailure, getGoogleSheetsSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* getGoogleSheetsSaga() {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const { data } = yield IntegrationService.getGoogleSheets(formId);
        yield put(getGoogleSheetsSuccess({ success: true, message: "", data: data.data }));
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to fetch Google Sheets";

        yield put(getGoogleSheetsFailure(errorMessage));
    }
}
